import BaseAbility from 'umg-ember-backend/abilities/base';

export default class ActionAbility extends BaseAbility {}
